import React from "react";
import BookDetailContainer from "../../book/bookDetail/components/BookDetailContainer";

// /bookRequest 는 /bookMultiRequest 로 redirect 되므로 이 라우트는 /book/:ordNum 상세만 담당.
const RouteBook = () => {
  return <BookDetailContainer />;
};

export default RouteBook;
